'use strict';

const SubteamApi = require('../../models/sub-team-api'),
	SubteamModel = require('../../models/sub-team-model'),
	mmWidgets = require('../../widgets/mm-widgets');
module.exports = function subteamStart(authentication, goldApi, s3Api, subscriptionModel) {
	const subteamApi = new SubteamApi(authentication, goldApi, s3Api),
		subteamModel = new SubteamModel(subteamApi, authentication.authenticationModel, s3Api, subscriptionModel),
		initialiseWidgets = () => {
			require('../../widgets/sub-team-list-widget');
			mmWidgets('[data-mm-role~="sub-team-list"]').subteamListWidget(subteamModel);

			require('../../widgets/sub-team-create-widget');
			mmWidgets('[data-mm-role~="add-sub-team"]').subteamCreateWidget(subteamModel);

			require('../../widgets/sub-team-delete-widget');
			mmWidgets('[data-mm-role~="confirm-delete-sub-team"]').subteamDeleteWidget(subteamModel);

			require('../../widgets/sub-team-config-widget');
			mmWidgets('[data-mm-role~="configure-sub-team"]').subteamConfigWidget(subteamModel);


			require('../../widgets/dispatched-event-toggle-widget');
			mmWidgets('[data-mm-sub-team-context]').dispatchedEventToggleWidget(subteamModel, ['context'], 'data-mm-sub-team-context', 'context-value', 'context-toggle-class');

		};
	return {
		api: subteamApi,
		model: subteamModel,
		initialiseWidgets: initialiseWidgets
	};
};
